var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.125 9.625c-.966 0-1.915.257-2.75.744V6.188a4.813 4.813 0 1 0-9.625 0v9.625a4.812 4.812 0 0 0 8.446 3.154 5.498 5.498 0 1 0 3.929-9.342zm0 1.375a4.128 4.128 0 0 1 4.063 3.438h-8.126A4.128 4.128 0 0 1 15.125 11zm-11-4.813a3.437 3.437 0 1 1 6.875 0v4.125H4.125V6.189zM7.563 19.25a3.442 3.442 0 0 1-3.438-3.438v-4.124h6.713a5.47 5.47 0 0 0-.497 6.14 3.43 3.43 0 0 1-2.778 1.422zm7.562 0a4.128 4.128 0 0 1-4.063-3.438h8.126a4.128 4.128 0 0 1-4.063 3.438z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicineIcon);
export default __webpack_public_path__ + "static/media/medicineIcon.1d7a7a3dc0979841369cefb61433962c.svg";
export { ForwardRef as ReactComponent };